// extracted by mini-css-extract-plugin
module.exports = {"wcmb8ol":"wcmb8ol"};